import React from 'react';
import { Modal, Input, Form } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
class CondicionComercialModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    condicionComercial: values.condicionComercial
                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        return (
            <Modal
                title={"Modificar Condición Comercial"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
                width={800}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Condición Comercial">
                                {getFieldDecorator('condicionComercial', {
                                    initialValue: this.props.formValues.condicionComercial,
                                    rules: [{
                                        required: false,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <TextArea
                                        placeholder="Ingresar Condición Comercial"
                                        autoComplete="off"
                                        style={{ height: 300 }}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(CondicionComercialModal)